import { render, staticRenderFns } from "./MedicationUnit.vue?vue&type=template&id=6debfe8e&scoped=true"
import script from "./MedicationUnit.vue?vue&type=script&lang=js"
export * from "./MedicationUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6debfe8e",
  null
  
)

export default component.exports